import React, { useEffect } from "react";
import Typed from 'typed.js';

const TypingEffect = () => {
    useEffect(() => {
        var typingEffect = new Typed(".title", {
            strings: ["Graphic Designer", "Web Developer", "Graphic Designer"],
            loop: true,
            typeSpeed: 100,
            backSpeed: 80,
        });
    }, []);

    return (

        <p className="title"> </p>

    );
};

export default TypingEffect;
